import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { fc } from 'i18n';
import { IMultipleEditForm } from 'types/tep';
import Input from 'core/react/general/form/Input';

import styles from './styles.module.css';

interface ICellProps {
  rowIndex: number;
}

export const PlateNumber: FC<ICellProps> = ({ rowIndex }) => {
  const { formState, control } = useFormContext<IMultipleEditForm>();

  const { errors } = formState;

  const error = errors.leases?.[rowIndex]?.plateNumber?.message;

  return (
    <>
      <Controller
        control={control}
        name={`leases.${rowIndex}.plateNumber`}
        rules={{ required: fc('please enter vehicle plate no.') }}
        render={({ value, onChange }) => (
          <div className={styles.input}>
            <Input placeholder="enter vehicle plate no." value={value} onChange={onChange} />
            {/*TODO: error messages should be moved to corresponding form components when they are being refactored*/}
            {!!error && <div className={styles.error}>{error}</div>}
          </div>
        )}
      />
    </>
  );
};
